import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import FeedbackForm from "@/pages/about/components/FeedbackForm";

const values = [
  { icon: "ri-stack-line", title: "丰富资源", desc: "覆盖电影、电视剧及 20+ 细分题材，持续更新收录。" },
  { icon: "ri-filter-3-line", title: "精准检索", desc: "支持类型、地区、年份多维筛选与关键词模糊搜索。" },
  { icon: "ri-lightbulb-line", title: "用心推荐", desc: "按观影场景策划专题片单，帮你更快找到好片。" },
  { icon: "ri-shield-check-line", title: "安全清爽", desc: "无弹窗、无诱导，专注纯净的影视信息浏览体验。" },
];

export default function About() {
  useSeo(
    "关于我们 - 看片网站",
    "了解看片网站的定位、服务理念、联系方式与版权免责声明，一个专注于影视内容检索与推荐的在线影视信息平台。",
    "关于看片网站,影视平台介绍,联系方式,免责声明"
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 md:px-6 md:py-10">
      <nav className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line leading-none"></i>
        <span className="text-foreground-900">关于我们</span>
      </nav>

      <section className="mt-5 overflow-hidden rounded-lg bg-primary-950 px-6 py-12 md:px-12 md:py-16">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
          <i className="ri-film-line leading-none"></i>
          关于看片网站
        </span>
        <h1 className="mt-4 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
          专注影视内容检索与推荐的在线平台
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
          看片网站致力于为影视爱好者提供清晰、高效的影视信息浏览体验。我们汇集海量电影与电视剧资料，
          通过多维度的分类与筛选工具，帮助你在庞大的影视库中快速定位感兴趣的作品，并了解完整的剧情简介与主创信息。
        </p>
      </section>

      <section className="mt-10">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">我们的定位</h2>
        <p className="mt-2 text-sm text-foreground-600">一个纯粹、好用的影视信息与检索平台</p>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-xl leading-none`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="contact" className="mt-12 scroll-mt-24">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">联系我们</h2>
        <p className="mt-2 text-sm text-foreground-600">如有任何建议或合作意向，欢迎通过以下方式与我们取得联系</p>
        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.2fr]">
          <div className="space-y-4">
            <div className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-mail-line text-lg leading-none"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">官方邮箱</p>
                <p className="mt-1 text-sm text-foreground-600">support@kanpian.example.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-time-line text-lg leading-none"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">响应时间</p>
                <p className="mt-1 text-sm text-foreground-600">工作日 9:00 - 18:00，我们会在 1-2 个工作日内回复</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className="ri-map-pin-line text-lg leading-none"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">服务范围</p>
                <p className="mt-1 text-sm text-foreground-600">面向全球中文影视爱好者提供内容检索服务</p>
              </div>
            </div>
          </div>
          <FeedbackForm />
        </div>
      </section>

      <section id="disclaimer" className="mt-12 scroll-mt-24">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">版权及免责声明</h2>
        <div className="mt-6 space-y-4 rounded-lg border border-background-200/70 bg-secondary-50 p-6 text-sm leading-relaxed text-foreground-700">
          <p>
            <strong className="text-foreground-950">一、内容性质：</strong>
            本站为影视信息聚合与检索平台，仅提供影视作品的名称、类型、地区、年份、简介等资料性信息展示，
            <strong className="text-foreground-950">不提供任何在线播放、下载或资源存储服务</strong>，站内亦不展示任何播放按钮。
          </p>
          <p>
            <strong className="text-foreground-950">二、数据说明：</strong>
            本站演示版本中的影视名称、封面与简介均为示例内容，仅用于产品功能展示，不代表真实作品信息。
          </p>
          <p>
            <strong className="text-foreground-950">三、版权归属：</strong>
            如涉及任何第三方内容版权，相关权利均归原作者及权利人所有。若有内容侵犯了您的合法权益，
            请通过上方联系方式与我们取得联系，我们将及时核实并处理。
          </p>
          <p>
            <strong className="text-foreground-950">四、收藏与分享：</strong>
            站内「收藏」功能基于浏览器本地存储实现，仅用于演示；「分享」功能将复制当前页面链接，均在本地完成。
          </p>
        </div>
      </section>
    </div>
  );
}